export const getDevServer = require('react-native/Libraries/Core/Devtools/getDevServer');
